export type PasswordStrength = {
  score: 0 | 1 | 2 | 3 | 4;
  label: string;
  segmentClass: string;
};

export function evaluatePasswordStrength(password: string): PasswordStrength {
  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  const capped = Math.min(4, score) as 0 | 1 | 2 | 3 | 4;

  const labels = ['Too weak', 'Weak', 'Fair', 'Good', 'Strong'];
  const colors = [
    'bg-danger',
    'bg-warning',
    'bg-warning',
    'bg-accent/80',
    'bg-accent',
  ];

  return {
    score: capped,
    label: labels[capped],
    segmentClass: colors[capped],
  };
}
